var VariationsWidget;

VariationsWidget = window.VariationsWidget != null ? window.VariationsWidget : window.VariationsWidget = {};

if (VariationsWidget.Models == null) {
  VariationsWidget.Models = {};
}

VariationsWidget.Models.Option = Backbone.Model.extend({
  initialize: function() {}
});

module.exports = VariationsWidget.Models.Option;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy92YXJpYXRpb25zL2Zyb250ZW5kL21vZGVscy9vcHRpb24uY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy92YXJpYXRpb25zL2Zyb250ZW5kL21vZGVscy9vcHRpb24uY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsZ0JBQUEscUNBQW1CLE1BQU0sQ0FBQyxtQkFBUCxNQUFNLENBQUMsbUJBQW9COzs7RUFDOUMsZ0JBQWdCLENBQUMsU0FBVTs7O0FBRTNCLGdCQUFnQixDQUFDLE1BQU0sQ0FBQyxNQUF4QixHQUFpQyxRQUFRLENBQUMsS0FBSyxDQUFDLE1BQWYsQ0FDL0I7RUFBQSxVQUFBLEVBQVksU0FBQSxHQUFBLENBQVo7Q0FEK0I7O0FBSWpDLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLGdCQUFnQixDQUFDLE1BQU0sQ0FBQyJ9
